
import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "../Styles/Navbar.css";
import GoogleTranslator from "./GoogleTranslator";
import logo from "../Assests/logo1.png";

function Navbar() {
    const location = useLocation();
    const [language, setLanguage] = useState("en");

    useEffect(() => {
        const detectLanguage = () => {
            const selected =
                document.querySelector(".goog-te-combo")?.value;

            const pageLanguage =
                document.documentElement.lang?.toLowerCase() || "";

            if (selected === "ta" || pageLanguage.startsWith("ta")) {
                setLanguage("ta");
            } else if (
                selected === "ml" ||
                pageLanguage.startsWith("ml")
            ) {
                setLanguage("ml");
            } else {
                setLanguage("en");
            }
        };

        document.addEventListener("change", detectLanguage);

        const observer = new MutationObserver(detectLanguage);

        observer.observe(document.documentElement, {
            attributes: true,
            attributeFilter: ["lang"],
        });

        detectLanguage();

        return () => {
            document.removeEventListener("change", detectLanguage);
            observer.disconnect();
        };
    }, []);

    const labels = {
        en: {
            about: "About",
            poojas: "Poojas",
            festivals: "Festivals",
            gallery: "Gallery",
            photos: "Photos",
            videos: "Videos",
            mediaTV: "Media TV",
            contact: "Contact",
            committee: "Committee",
            back: "Back",
        },
        ta: {
            about: "வரலாறு",
            poojas: "பூஜைகள்",
            festivals: "திருவிழாக்கள்",
            gallery: "புகைப்படங்கள்",
            photos: "புகைப்படங்கள்",
            videos: "காணொளிகள்",
            mediaTV: "மீடியா டிவி",
            contact: "தொடர்பு",
            committee: "நிர்வாகம்",
            back: "பின்னால்",
        },
    };

    // Malayalam uses English source labels so Google Translate can translate them.
    const text = language === "ta" ? labels.ta : labels.en;

    const label = (value) =>
        language === "ta" ? (
            <span className="notranslate" translate="no">
                {value}
            </span>
        ) : (
            value
        );

    return (
        <header className="temple-header">
            <div className="top-header container-fluid">
                <div className="logo-section">
                    <img
                        src={logo}
                        alt="Temple Logo"
                        className="temple-logo"
                    />
                </div>

                <div className="title-section">
                    <h1>Nambooriyachan Aalkshethra Sevasamithi</h1>
                    <p><b>RegNo: EKM/TC/544/2014</b></p>
                    <p>"Faith • Devotion • Tradition"</p>
                </div>

                <div className="back-section">
                    {location.pathname !== "/" && (
                        <Link to="/" className="back-btn">
                            <i className="bi bi-arrow-left-circle"></i>{" "}
                            {label(
                                language === "ta"
                                    ? labels.ta.back
                                    : labels.en.back
                            )}
                        </Link>
                    )}
                </div>
            </div>

            <nav className="navbar navbar-expand-lg navbar-dark temple-navbar">
                <div className="container">
                    <button
                        className="navbar-toggler"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#menu"
                        aria-controls="menu"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                    >
                        <span className="navbar-toggler-icon"></span>
                    </button>

                    <div
                        className="collapse navbar-collapse justify-content-center"
                        id="menu"
                    >
                        <ul className="navbar-nav">
                            <li className="nav-item">
                                <Link className="nav-link" to="/about">
                                    {label(text.about)}
                                </Link>
                            </li>

                            <li className="nav-item">
                                <Link className="nav-link" to="/poojas">
                                    {label(text.poojas)}
                                </Link>
                            </li>

                            <li className="nav-item">
                                <Link className="nav-link" to="/festivals">
                                    {label(text.festivals)}
                                </Link>
                            </li>

                            <li className="nav-item dropdown">
                                <a
                                    className="nav-link dropdown-toggle"
                                    href="#gallery"
                                    role="button"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    {label(text.gallery)}
                                </a>

                                <ul className="dropdown-menu">
                                    <li>
                                        <Link
                                            className="dropdown-item"
                                            to="/gallery/photos"
                                        >
                                            📷 {label(text.photos)}
                                        </Link>
                                    </li>

                                    <li>
                                        <Link
                                            className="dropdown-item"
                                            to="/gallery/videos"
                                        >
                                            🎥 {label(text.videos)}
                                        </Link>
                                    </li>

                                    <li>
                                        <Link
                                            className="dropdown-item"
                                            to="/gallery/media-tv"
                                        >
                                            📺 {label(text.mediaTV)}
                                        </Link>
                                    </li>
                                </ul>
                            </li>

                            <li className="nav-item">
                                <Link className="nav-link" to="/contact">
                                    {label(text.contact)}
                                </Link>
                            </li>

                            <li className="nav-item">
                                <Link
                                    className="nav-link"
                                    to="/Committee"
                                >
                                    {label(text.committee)}
                                </Link>
                            </li>

                            <li className="nav-item translator-item">
                                <GoogleTranslator />
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        </header>
    );
}

export default Navbar;

